/**
 * DOCS_COLOR_SCHEME_KEY is the localStorage slot the docs color-scheme choice
 * persists to. It is docs-owned and unique, so the docs app's persistence never
 * collides with another app's color-scheme slot on the same origin. The provider
 * (via its color-scheme manager) and the no-flash head script both read and write
 * this exact key, so the value is single-sourced here.
 */
export const DOCS_COLOR_SCHEME_KEY = "mountaya-docs-color-scheme";
